import firebase from 'firebase';

export const FIREBASE_CONFIG = {
  apiKey: process.env.APP_FIREBASE_API_KEY,
  authDomain: process.env.APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.APP_FIREBASE_MESSAGING_SENDER_ID,
  mapsApiKey: process.env.APP_GOOGLE_MAPS_API_KEY,
  appId: process.env.APP_FIREBASE_APP_ID,
  measurementId: process.env.APP_FIREBASE_MEASUREMENT_ID,
};

export function initializeFirebase(): firebase.app.App {
  const app = firebase.initializeApp(FIREBASE_CONFIG);
  firebase.analytics();

  if (process.env.NODE_ENV === 'development' && process.env.APP_FIREBASE_EMULATOR === 'true') {
    console.warn('Using Local Functions Emulator at http://localhost:5001');
    app.functions().useEmulator('localhost', 5001);
  }

  return app;
}
